export default __webpack_public_path__ + "static/media/portfoliohubnmail.89e1fa8d.png";